import {Component, OnDestroy, OnInit} from '@angular/core';
import {animate, AUTO_STYLE, state, style, transition, trigger} from '@angular/animations';
import {Menu, MenuItems} from '../../shared/menu-items/menu-items';
import {LocalStorageService} from 'angular-web-storage';
import {ToastData, ToastOptions, ToastyService} from 'ng2-toasty';
import {BackendApiService} from '../../services/backend-api.service';
import {Location} from '@angular/common';
import {Router} from '@angular/router';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import {BnNgIdleService} from 'bn-ng-idle';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {ResizedEvent} from 'angular-resize-event';
import {LiveNotificactions} from '../../services/NotificactionsLive';
import {AMBIENTE} from '../../../config';
import * as moment from 'moment';
import {NgbTooltipConfig} from '@ng-bootstrap/ng-bootstrap';
import {UserNotificationService} from '../../services/usernotification.service';
import {ToolsService} from '../../services/tools.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {JwtHelperService} from '@auth0/angular-jwt';
import {MenuItem} from 'primeng/components/common/menuitem';

@Component({
   selector: 'app-admin',
   templateUrl: './admin.component.html',
   styleUrls: ['./admin.component.scss'],
   animations: [
      trigger('notificationBottom', [
         state('an-off, void',
           style({
              overflow: 'hidden',
              height: '0px',
           })
         ),
         state('an-animate',
           style({
              overflow: 'visible',
              height: AUTO_STYLE,
           })
         ),
         transition('an-off <=> an-animate', [
            animate('400ms ease-in-out')
         ])
      ]),
      trigger('slideInOut', [
         state('in', style({
            width: '280px',
            // transform: 'translate3d(0, 0, 0)'
         })),
         state('out', style({
            width: '0',
            // transform: 'translate3d(100%, 0, 0)'
         })),
         transition('in => out', animate('400ms ease-in-out')),
         transition('out => in', animate('400ms ease-in-out'))
      ]),
      trigger('mobileHeaderNavRight', [
         state('nav-off, void',
           style({
              overflow: 'hidden',
              height: '0px',
           })
         ),
         state('nav-on',
           style({
              height: AUTO_STYLE,
           })
         ),
         transition('nav-off <=> nav-on', [
            animate('400ms ease-in-out')
         ])
      ]),
      trigger('fadeInOutTranslate', [
         transition(':enter', [
            style({opacity: 0}),
            animate('400ms ease-in-out', style({opacity: 1}))
         ]),
         transition(':leave', [
            style({transform: 'translate(0)'}),
            animate('400ms ease-in-out', style({opacity: 0}))
         ])
      ]),
      trigger('mobileMenuTop', [
         state('no-block, void',
           style({
              overflow: 'hidden',
              height: '0px',
           })
         ),
         state('yes-block',
           style({
              height: AUTO_STYLE,
           })
         ),
         transition('no-block <=> yes-block', [
            animate('400ms ease-in-out')
         ])
      ])
   ]
})
export class AdminComponent implements OnInit, OnDestroy {
   public toggleOn: boolean;
   public isVerticalLayoutChecked: boolean;
   public isSidebarChecked: boolean;
   public isHeaderChecked: boolean;
   public subItemBorder: boolean;
   public itemBorder: boolean;
   public boolEvtResized: boolean = false;
   
   public ambiente: string;
   public position: string = 'top-right';
   public animateSidebar: string;
   public navType: string;
   public themeLayout: string;
   public verticalPlacement: string;
   public verticalLayout: string;
   public pcodedDeviceType: string;
   public verticalNavType: string;
   public verticalEffect: string;
   public vnavigationView: string;
   public freamType: string;
   public sidebarImg: string;
   public sidebarImgType: string;
   public layoutType: string;
   public headerTheme: string;
   public pcodedHeaderPosition: string;
   public liveNotification: string;
   public liveNotificationClass: string;
   public profileNotification: string;
   public profileNotificationClass: string;
   public chatSlideInOut: string;
   public innerChatSlideInOut: string;
   public searchWidth: number;
   public searchWidthString: string;
   public navRight: string;
   public windowWidth: number;
   public chatTopPosition: string;
   public toggleIcon: string;
   public navBarTheme: string;
   public activeItemTheme: string;
   public pcodedSidebarPosition: string;
   public headerFixedTop: string;
   public menuTitleTheme: string;
   public dropDownIcon: string;
   public subItemIcon: string;
   public configOpenRightBar: string;
   public displayBoxLayout: string;
   public headerFixedMargin: string;
   public sidebarFixedHeight: string;
   public sidebarFixedNavHeight: string;
   public itemBorderStyle: string;
   public isCollapsedSideBar: string;
   public perfectDisable: string;
   public userName: string;
   public version: string;
   
   public lsLiveNotifications = new Array<LiveNotificactions>();
   
   public timer: any;
   public config: any;
   public searchInterval: any;
   public foto: any;
   public infoUser: any;
   public usuario: any;
   
   // public lsDxMenu: any[];
   
   public lsMenuItems: Menu[];
   public lsNuevoMenu: MenuItem[]
   public isResponsiveMenu = false
   
   public searchMenu$ = new Subject<string>();
   
   private destroy$: Subject<boolean> = new Subject<boolean>();
   
   scroll = (): void => {
      const scrollPosition = window.pageYOffset;
      
      if (scrollPosition > 50) {
         if (this.isSidebarChecked === true) {
            this.pcodedSidebarPosition = 'fixed';
         }
         
         if (this.pcodedDeviceType === 'desktop') {
            this.headerFixedTop = '0';
         }
         
         this.sidebarFixedNavHeight = '100%';
      } else {
         if (this.pcodedDeviceType === 'desktop') {
            this.headerFixedTop = 'auto';
         }
         
         this.pcodedSidebarPosition = 'absolute';
         this.sidebarFixedNavHeight = '';
      }
   };
   
   constructor(
     private ngxLoadService: NgxUiLoaderService,
     private location: Location,
     private bnIdle: BnNgIdleService,
     public toastyService: ToastyService,
     public router: Router,
     public service: BackendApiService,
     public menuItems: MenuItems,
     public storage: LocalStorageService,
     public ngbTooltipConfig: NgbTooltipConfig,
     private userNotification: UserNotificationService,
     private toolsService: ToolsService,
     private readonly jwtHelperService: JwtHelperService
   ) {
      ngbTooltipConfig.container = 'body';
      
      this.bnIdle.startWatching(5400).subscribe((res) => {
         const oToken = this.storage.get('jwt');
         const bTokenExpired = this.jwtHelperService.isTokenExpired(oToken);
         
         if (bTokenExpired) {
            this.userNotification.modalInfo(
              'warning',
              'Sesión caducada',
              'Por seguridad, vuelve a iniciar sesión'
            );
            
            this.logout();
            return false;
         }
      });
      
      this.animateSidebar = '';
      this.navType = 'st2';
      this.themeLayout = 'vertical';
      this.verticalPlacement = 'left';
      this.verticalLayout = 'wide';
      this.pcodedDeviceType = 'desktop';
      this.verticalNavType = 'expanded';
      this.verticalEffect = 'shrink';
      this.vnavigationView = 'view1';
      this.freamType = 'theme1';
      this.sidebarImg = 'false';
      this.sidebarImgType = 'img1';
      this.layoutType = 'light'; // light(default) dark(dark)
      this.headerTheme = 'theme1'; // theme1(default)
      this.pcodedHeaderPosition = 'fixed';
      this.headerFixedTop = 'auto';
      this.liveNotification = 'an-off';
      this.profileNotification = 'an-off';
      this.chatSlideInOut = 'out';
      this.innerChatSlideInOut = 'out';
      this.searchWidth = 0;
      this.navRight = 'nav-on';
      this.toggleOn = true;
      this.toggleIcon = 'icon-toggle-right';
      this.navBarTheme = 'themelight1'; // themelight1(default) theme1(dark)
      this.activeItemTheme = 'theme1';
      this.pcodedSidebarPosition = 'fixed';
      this.menuTitleTheme = 'theme1'; // theme1(default) theme10(dark)
      this.dropDownIcon = 'style1';
      this.subItemIcon = 'style1';
      this.displayBoxLayout = 'd-none';
      this.isVerticalLayoutChecked = true;
      this.isSidebarChecked = true;
      this.isHeaderChecked = true;
      this.headerFixedMargin = '50px'; // 50px
      this.sidebarFixedHeight = 'calc(100vh - 55px)'; // calc(100vh - 190px)
      this.itemBorderStyle = 'none';
      this.subItemBorder = true;
      this.itemBorder = true;
      this.isCollapsedSideBar = 'no-block';
      this.perfectDisable = '';
      this.windowWidth = window.innerWidth;
      this.setMenuAttributes(this.windowWidth);
      this.setHeaderAttributes(this.windowWidth);
      
      // dark theme
      /*this.setLayoutType('dark');*/
      
      // light-dark
      /*this.setLayoutType('dark');
      this.setNavBarTheme('themelight1');*/
      
      // dark-light theme
      /*this.setNavBarTheme('theme1');*/
      
      // box layout
      this.setHeaderPosition();
      this.setSidebarPosition();
      this.setVerticalLayout();
   }
   
   async ngOnInit() {
      this.ambiente = AMBIENTE;
      this.version = require('../../../../package.json').version;
      this.getMenuUser();
      // this.lsDxMenu = this.storage.get('menuDx');
      await this.validatePermissions();
      this.setBackgroundPattern('theme1');
      
      if (this.storage.get('usuario') != null) {
         this.usuario = this.storage.get('usuario');
         this.userName = this.storage.get('usuario').name;
         
         this.service.get(`api/data-user/${this.userName}`).subscribe((data: any) => {
            delete data.diasPorPeriodo;
            delete data.totalDiasDisponibles;
            delete data.totalFlexibles;
            
            data.codigo = data.visitador.trim();
            data.apellidos = data.apellidos.trim();
            data.nombres = data.nombres.trim();
            data.nombreCompleto = data.apellidos + ' ' + data.nombres;
            data.descripcion = data.descripcion.toUpperCase().trim();
            data.email = data.email.trim();
            this.infoUser = data;
            this.storage.set('infoUser', this.infoUser);
            this.foto = this.infoUser.foto || '';
            
            if (moment(data.fechaIngreso).format('MMDD') == moment().format('MMDD')) {
               this.lsLiveNotifications.push({
                  imagePath: '',
                  image: this.infoUser.foto,
                  user: 'Laboratorios Bagó',
                  message: 'Feliz Aniversario N° ' + moment().diff(moment(data.fechaIngreso), 'years').toString() + ' en nuestra querida empresa',
                  time: moment().format('YYYY-MM-DD HH:mm:ss'),
                  type: 'bago'
               });
            }
            
            if (moment(data.fechaNacimiento).format('MMDD') == moment().format('MMDD')) {
               this.lsLiveNotifications.push({
                  imagePath: '',
                  image: this.infoUser.foto,
                  user: 'Laboratorios Bagó',
                  message: 'Feliz Cumpleaños ' + this.toolsService.setTitleCase(this.infoUser.nombres),
                  time: moment().format('YYYY-MM-DD HH:mm:ss'),
                  type: 'success'
               });
            }
         });
      }
   }
   
   public getMenuUser() {
      this.menuItems.getMenu().then(data => {
         this.lsMenuItems = data;
         if (data && data[0]) {
            this.lsNuevoMenu = this.generarItemsDeMenu(data[0]?.main)
         }
         // this.searchMenuUser();
      });
   }
   
   generarItemsDeMenu(item: any[]) {
      return item.map((item) => ({
         label: item.name,
         badge: item?.type,
         icon: item.icon,
         command: this.accionOpcioneMenu,
         expanded: false,
         routerLink: !item.children ? item.url : !item?.children?.length ? item.url : undefined,
         items: item.children && item.children.length ? this.generarItemsDeMenu(item.children) : null
      }))
   }
   
   accionOpcioneMenu(_event: any) {}
   
   public searchMenuUser() {
      if (this.lsMenuItems) {
         this.menuItems.search(this.searchMenu$, this.lsMenuItems)
           .pipe(
             takeUntil(this.destroy$)
           ).subscribe(data => {
            this.lsMenuItems = data;
         });
      }
   }
   
   public login() {
      this.storage.remove('jwt');
      this.service.post('api/login', this.usuario).subscribe((data: any) => {
      }, error => {
         this.logout();
      });
   }
   
   public logout() {
      this.storage.clear();
      this.router.navigateByUrl('seguridad/login');
   }
   
   public async validatePermissions() {
      let lsData: any;
      let oItem: any;
      
      this.usuario = this.storage.get('usuario');
      lsData = await this.storage.get('menu');
      oItem = lsData != null ? lsData.find(x => x.STATE == this.location.path() && x.TYPE == 'link') : null;
      
      if (!oItem) {
         if (this.location.path() != '/home') {
            // this.router.navigateByUrl('home');
            // this.userNotification.modalInfo('warning', 'Acceso restringido.', 'Solicite acceso al administrador del sistema.');
         }
      }
   }
   
   public onResize(event) {
      if (this.boolEvtResized) {
         this.boolEvtResized = !this.boolEvtResized;
         return;
      }
      let reSizeFlag = true;
      
      this.windowWidth = event.target.innerWidth;
      this.setHeaderAttributes(this.windowWidth);
      
      if (this.pcodedDeviceType === 'tablet' && this.windowWidth >= 768 && this.windowWidth <= 992) {
         reSizeFlag = false;
      } else if (this.pcodedDeviceType === 'phone' && this.windowWidth < 768) {
         reSizeFlag = false;
      }
      
      /* for check device */
      if (reSizeFlag) {
         this.setMenuAttributes(this.windowWidth);
      }
   }
   
   public onResized(event: ResizedEvent) {
      setTimeout(() => {
         this.boolEvtResized = true;
         window.dispatchEvent(new Event('resize'));
      }, 250);
   }
   
   public setHeaderAttributes(windowWidth) {
      if (windowWidth <= 992) {
         this.navRight = 'nav-off';
      } else {
         this.navRight = 'nav-on';
      }
   }
   
   public setMenuAttributes(windowWidth) {
   
      if (windowWidth >= 768 && windowWidth <= 992) {
         this.pcodedDeviceType = 'tablet';
         this.verticalNavType = 'offcanvas';
         this.verticalEffect = 'overlay';
         this.toggleIcon = 'icon-toggle-left';
         this.headerFixedTop = '50px';
         this.headerFixedMargin = '0';
      } else if (windowWidth < 768) {
         this.pcodedDeviceType = 'phone';
         this.verticalNavType = 'offcanvas';
         this.verticalEffect = 'overlay';
         this.toggleIcon = 'icon-toggle-left';
         this.headerFixedTop = '50px';
         this.headerFixedMargin = '0';
      } else {
         this.pcodedDeviceType = 'desktop';
         this.verticalNavType = 'expanded';
         this.verticalEffect = 'shrink';
         this.toggleIcon = 'icon-toggle-right';
         this.headerFixedMargin = '50px';
      }
   }
   
   public toggleHeaderNavRight() {
      this.navRight = this.navRight === 'nav-on' ? 'nav-off' : 'nav-on';
      this.chatTopPosition = this.chatTopPosition === 'nav-on' ? '112px' : '';
      
      if (this.navRight === 'nav-off' && this.innerChatSlideInOut === 'in') {
         this.toggleInnerChat();
      }
      
      if (this.navRight === 'nav-off' && this.chatSlideInOut === 'in') {
         this.toggleChat();
      }
   }
   
   public toggleLiveNotification() {
      if (this.profileNotification === 'an-animate') {
         this.toggleProfileNotification();
      }
      
      this.liveNotification = this.liveNotification === 'an-off' ? 'an-animate' : 'an-off';
      this.liveNotificationClass = this.liveNotification === 'an-animate' ? 'show' : '';
      
      if (this.liveNotification === 'an-animate' && this.innerChatSlideInOut === 'in') {
         this.toggleInnerChat();
      }
      
      if (this.liveNotification === 'an-animate' && this.chatSlideInOut === 'in') {
         this.toggleChat();
      }
   }
   
   public toggleProfileNotification() {
      if (this.liveNotification === 'an-animate') {
         this.toggleLiveNotification();
      }
      
      this.profileNotification = this.profileNotification === 'an-off' ? 'an-animate' : 'an-off';
      this.profileNotificationClass = this.profileNotification === 'an-animate' ? 'show' : '';
      
      if (this.profileNotification === 'an-animate' && this.innerChatSlideInOut === 'in') {
         this.toggleInnerChat();
      }
      
      if (this.profileNotification === 'an-animate' && this.chatSlideInOut === 'in') {
         this.toggleChat();
      }
   }
   
   public notificationOutsideClick(ele: string) {
      if (ele === 'live' && this.liveNotification === 'an-animate') {
         this.toggleLiveNotification();
      } else if (ele === 'profile' && this.profileNotification === 'an-animate') {
         this.toggleProfileNotification();
      }
   }
   
   public toggleChat() {
      if (this.innerChatSlideInOut === 'in') {
         this.innerChatSlideInOut = 'out';
      } else {
         this.chatSlideInOut = this.chatSlideInOut === 'out' ? 'in' : 'out';
      }
   }
   
   public toggleInnerChat() {
      this.innerChatSlideInOut = this.innerChatSlideInOut === 'out' ? 'in' : 'out';
   }
   
   public searchOn() {
      document.querySelector('#main-search').classList.add('open');
      
      this.searchInterval = setInterval(() => {
           if (this.searchWidth >= 200) {
              clearInterval(this.searchInterval);
              
              return false;
           }
           
           this.searchWidth = this.searchWidth + 12;
           this.searchWidthString = this.searchWidth + 'px';
        }, 20
      );
   }
   
   public searchOff() {
      this.searchMenu$.next('');
      
      this.searchInterval = setInterval(() => {
           if (this.searchWidth <= 0) {
              document.querySelector('#main-search').classList.remove('open');
              clearInterval(this.searchInterval);
              
              return false;
           }
           
           this.searchWidth = this.searchWidth - 12;
           this.searchWidthString = this.searchWidth + 'px';
        }, 20
      );
   }
   
   public ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.unsubscribe();
      
      if (this.searchInterval) {
         clearInterval(this.searchInterval);
      }
   }
   
   public toggleOpened(e) {
   
      if (this.windowWidth <= 992) {
         this.toggleOn = this.verticalNavType === 'offcanvas' ? true : this.toggleOn;
         
         if (this.navRight === 'nav-on') {
            this.toggleHeaderNavRight();
         }
         
         this.verticalNavType = this.verticalNavType === 'expanded' ? 'offcanvas' : 'expanded';
      } else {
         this.verticalNavType = this.verticalNavType === 'expanded' ? 'collapsed' : 'expanded';
      }
      
      this.toggleIcon = this.verticalNavType === 'expanded' ? 'icon-toggle-right' : 'icon-toggle-left';
      this.animateSidebar = 'pcoded-toggle-animate';
      
      if (this.verticalNavType === 'collapsed') {
         this.perfectDisable = 'disabled';
         this.sidebarFixedHeight = '100%';
      } else {
         this.perfectDisable = '';
      }
      
      if (this.verticalNavType === 'collapsed' && this.isHeaderChecked === false) {
         this.setSidebarPosition();
      }
   
      this.isResponsiveMenu = !this.lsNuevoMenu
      setTimeout(() => {
         this.animateSidebar = '';
      }, 500);
   }
   
   public onClickedOutsideSidebar(e: Event) {
      if ((this.windowWidth <= 992 && this.toggleOn && this.verticalNavType !== 'offcanvas') || this.verticalEffect === 'overlay') {
         this.toggleOn = true;
         this.verticalNavType = 'offcanvas';
         this.toggleIcon = 'icon-toggle-left';
      }
   }
   
   public toggleRightbar() {
      this.configOpenRightBar = this.configOpenRightBar === 'open' ? '' : 'open';
   }
   
   public setNavBarTheme(theme: string) {
      if (theme === 'themelight1') {
         this.navBarTheme = 'themelight1';
         this.menuTitleTheme = 'theme1';
         this.sidebarImg = 'false';
      } else {
         this.menuTitleTheme = 'theme9';
         this.navBarTheme = 'theme1';
         this.sidebarImg = 'false';
      }
   }
   
   public setLayoutType(type: string) {
      if (type === 'dark') {
         this.headerTheme = 'theme1';
         this.navBarTheme = 'theme1';
         this.activeItemTheme = 'theme1';
         this.freamType = 'theme1';
         document.querySelector('body').classList.add('dark');
         this.setBackgroundPattern('theme1');
         this.menuTitleTheme = 'theme9';
         this.layoutType = type;
         this.sidebarImg = 'false';
      } else if (type === 'light') {
         this.headerTheme = 'theme1';
         this.navBarTheme = 'themelight1';
         this.menuTitleTheme = 'theme1';
         this.activeItemTheme = 'theme1';
         this.freamType = 'theme1';
         document.querySelector('body').classList.remove('dark');
         this.setBackgroundPattern('theme1');
         this.layoutType = type;
         this.sidebarImg = 'false';
      } else if (type === 'img') {
         this.sidebarImg = 'true';
         this.navBarTheme = 'themelight1';
         this.menuTitleTheme = 'theme1';
         this.freamType = 'theme1';
         document.querySelector('body').classList.remove('dark');
         this.setBackgroundPattern('theme1');
         this.activeItemTheme = 'theme1';
      }
   }
   
   public setVerticalLayout() {
      this.isVerticalLayoutChecked = !this.isVerticalLayoutChecked;
      
      if (this.isVerticalLayoutChecked) {
         this.verticalLayout = 'box';
         this.displayBoxLayout = '';
         this.pcodedHeaderPosition = 'relative';
         this.pcodedSidebarPosition = 'absolute';
         this.headerFixedMargin = '';
      } else {
         this.verticalLayout = 'wide';
         this.displayBoxLayout = 'd-none';
         this.pcodedHeaderPosition = 'fixed';
         this.pcodedSidebarPosition = 'fixed';
         this.headerFixedMargin = '50px';
      }
   }
   
   public setBackgroundPattern(pattern: string) {
      document.querySelector('body').setAttribute('themebg-pattern', pattern);
   }
   
   public setSidebarPosition() {
      if (this.verticalNavType !== 'collapsed') {
         this.isSidebarChecked = !this.isSidebarChecked;
         this.pcodedSidebarPosition = this.isSidebarChecked === true ? 'fixed' : 'absolute';
         this.sidebarFixedHeight = this.isSidebarChecked === true ? 'calc(100vh - 50px)' : '100%';
         
         if (this.isHeaderChecked === false) {
            window.addEventListener('scroll', this.scroll, true);
            window.scrollTo(0, 0);
         }
      }
   }
   
   public setHeaderPosition() {
      this.isHeaderChecked = !this.isHeaderChecked;
      this.pcodedHeaderPosition = this.isHeaderChecked === true ? 'fixed' : 'relative';
      this.headerFixedMargin = this.isHeaderChecked === true ? '50px' : '';
      
      if (this.isHeaderChecked === false) {
         window.addEventListener('scroll', this.scroll, true);
         window.scrollTo(0, 0);
      } else {
         window.removeEventListener('scroll', this.scroll, true);
         
         if (this.pcodedDeviceType === 'desktop') {
            this.headerFixedTop = 'auto';
         }
         
         this.pcodedSidebarPosition = 'fixed';
         
         if (this.verticalNavType !== 'collapsed') {
            this.sidebarFixedHeight = this.isSidebarChecked === true ? 'calc(100vh - 50px)' : 'calc(100vh + 50px)';
         }
      }
   }
   
   public toggleOpenedSidebar() {
      this.isCollapsedSideBar = this.isCollapsedSideBar === 'yes-block' ? 'no-block' : 'yes-block';
      
      if (this.verticalNavType !== 'collapsed') {
         this.sidebarFixedHeight = this.isCollapsedSideBar === 'yes-block' ? 'calc(100vh - 50px)' : 'calc(100vh - 50px)';
      }
   }
   
   public hoverOutsideSidebar() {
      if (this.verticalNavType === 'collapsed') {
         const mainEle = document.querySelectorAll('.pcoded-trigger');
         
         for (let i = 0; i < mainEle.length; i++) {
            mainEle[i].classList.remove('pcoded-trigger');
         }
      }
   }
   
   public fireClick(e) {
      if (this.verticalNavType === 'collapsed') {
         const parentEle = e.target.parentNode.parentNode;
         
         if (parentEle.classList.contains('pcoded-trigger')) {
            const subEle = parentEle.querySelectorAll('.pcoded-hasmenu');
            
            for (let i = 0; i < subEle.length; i++) {
               if (subEle[i].classList.contains('pcoded-trigger')) {
                  subEle[i].classList.remove('pcoded-trigger');
               }
            }
         } else {
            e.target.click();
         }
      }
   }
   
   public fireClickLeave(e) {
      if (this.verticalNavType === 'collapsed') {
         const parentEle = <HTMLElement>e.target.parentNode.parentNode;
         const subEle = parentEle.querySelectorAll('.pcoded-hasmenu');
         
         for (let i = 0; i < subEle.length; i++) {
            if (subEle[i].classList.contains('pcoded-trigger')) {
               subEle[i].classList.remove('pcoded-trigger');
            }
         }
      }
   }
   
   public addToast(options) {
      if (options.closeOther) {
         this.toastyService.clearAll();
      }
      
      this.position = options.position ? options.position : this.position;
      
      const toastOptions: ToastOptions = {
         title: options.title,
         msg: options.msg,
         showClose: options.showClose,
         timeout: options.timeout,
         theme: options.theme,
         onAdd: (toast: ToastData) => {
            /* added */
         },
         onRemove: (toast: ToastData) => {
            /* removed */
         }
      };
      
      switch (options.type) {
         case 'default':
            this.toastyService.default(toastOptions);
            break;
         
         case 'info':
            this.toastyService.info(toastOptions);
            break;
         
         case 'success':
            this.toastyService.success(toastOptions);
            break;
         
         case 'wait':
            this.toastyService.wait(toastOptions);
            break;
         
         case 'error':
            this.toastyService.error(toastOptions);
            break;
         
         case 'warning':
            this.toastyService.warning(toastOptions);
            break;
      }
   }
   
   public getUserDataInfo() {
      let bAniversario: boolean;
      let bCumpleaños: boolean;
      let sMessage: any = '';
      let oInfoUser: any = this.storage.get('infoUser');
      
      if (!oInfoUser) {
         return;
      }
      
      bAniversario = moment(oInfoUser.fechaIngreso).format('MMDD') == moment().format('MMDD');
      bCumpleaños = moment(oInfoUser.fechaNacimiento).format('MMDD') == moment().format('MMDD');
      
      if (bCumpleaños) {
         sMessage = sMessage + '<label class="label label-success text-size-20">';
         sMessage = sMessage + '  <span >';
         sMessage = sMessage + '     <b>Feliz Cumpleaños...!</b>';
         sMessage = sMessage + '  </span>';
         sMessage = sMessage + '</label>';
         sMessage = sMessage + '<img class="img-menu-user badge-bago" src="assets/images/' + (oInfoUser.genero == '1' ? 'feliz_cumple_hombre.jpg' : 'feliz_cumple_mujer.jpg') + '" alt="Sin foto de usuario" width="450px" height="220px">';
      } else {
         sMessage = sMessage + '<img class="img-menu-user img-radius" src="' + (oInfoUser.foto || '') + '" alt="Sin foto de usuario" width="160px" height="160px">';
         sMessage = sMessage + '<br>';
         sMessage = sMessage + '<div style="text-align: left; margin-top: 10px; margin-bottom: -10px;">';
         sMessage = sMessage + '  <b>Código:</b> ' + oInfoUser.codigo;
         sMessage = sMessage + '  <br>';
         sMessage = sMessage + '  <b>Cargo:</b> ' + this.toolsService.setTitleCase(oInfoUser.descripcion);
         sMessage = sMessage + '  <br>';
         sMessage = sMessage + '  <b>Email:</b> ' + oInfoUser.email;
         sMessage = sMessage + '  <br>';
         sMessage = sMessage + '  <b>Teléfono:</b> ' + oInfoUser.telefono;
         sMessage = sMessage + '  <br>';
         sMessage = sMessage + '  <b>Fecha de Nacimiento:</b> ' + this.toolsService.parseDate(oInfoUser.fechaNacimiento, 'YYYY-MM-DD');
         sMessage = sMessage + '</div>';
      }
      
      if (bAniversario) {
         sMessage = sMessage + '<br>';
         sMessage = sMessage + '<label class="label label-bago text-size-18" style="margin-top: 10px; margin-bottom: 10px;">';
         sMessage = sMessage + '  <span >';
         sMessage = sMessage + '     <b>Feliz Aniversario N° ' + moment().diff(moment(oInfoUser.fechaIngreso), 'years') + ' en nuestra querida empresa...! ' + '</b>';
         sMessage = sMessage + '  </span>';
         sMessage = sMessage + '</label>';
      }
      
      this.userNotification.modalInfoHtml(undefined, this.toolsService.setTitleCase(oInfoUser.nombreCompleto), sMessage);
   }
   
   isCollapsed = false;
   
   toggleCollapsed(): void {
      this.isCollapsed = !this.isCollapsed;
   }
}
